import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import queryString from 'query-string';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import {
  sidebarDebug,
  summarizeMenuNode,
} from 'src/app/shared/sidebar/sidebar-debug';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
  sidebarExpanded = true;
  mobileDrawerOpen = false;
  menuItems: any[] = [];
  cats: any[] = [];

  private readonly destroy$ = new Subject<void>();

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private router: Router,
  ) {
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        this.mobileDrawerOpen = false;
      });
  }

  ngOnInit(): void {
    this.loadMenus();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadMenus(): void {
    const queryMenu = queryString.stringify({
      userId: this.authService.getUserId(),
      webId: 'F64B0750-2B1D-4011-89FF-36642C1D65BE',
    });

    this.apiService.getWebMenuListByUserId1(queryMenu).subscribe({
      next: (res) => {
        sidebarDebug('GetWebMenuListByUserId raw response', {
          resKeys: res && typeof res === 'object' ? Object.keys(res as object) : [],
          status: (res as { status?: string })?.status,
          hasData: !!res?.data,
          dataKeys:
            res?.data && typeof res.data === 'object'
              ? Object.keys(res.data as object)
              : [],
        });
        const data = res?.data;
        if (!data) {
          sidebarDebug('GetWebMenuListByUserId: res.data is empty — menuItems unchanged');
          return;
        }
        const menus = data.webMenus ?? data.WebMenus;
        this.menuItems = Array.isArray(menus) ? menus : [];
        sidebarDebug('GetWebMenuListByUserId parsed menuItems', {
          assignedLength: this.menuItems.length,
          usedKey: Array.isArray(data.webMenus)
            ? 'webMenus'
            : Array.isArray(data.WebMenus)
              ? 'WebMenus'
              : 'neither (menuItems forced [])',
          firstRoot: this.menuItems[0]
            ? summarizeMenuNode(this.menuItems[0])
            : null,
        });
      },
      error: (err) => {
        sidebarDebug('GetWebMenuListByUserId HTTP error', {
          message: err?.message,
          status: err?.status,
        });
      },
    });

    const queryParams = queryString.stringify({
      webId: 'F64B0750-2B1D-4011-89FF-36642C1D65BE',
    });
    this.apiService
      .getWebManagements(queryParams)
      .pipe(takeUntil(this.destroy$))
      .subscribe((results: any) => {
        if (results?.data?.length > 0) {
          this.cats = results.data;
        }
      });
  }

  toggleSidebar(): void {
    this.sidebarExpanded = !this.sidebarExpanded;
  }
}
